export default __webpack_public_path__ + "static/media/rebuke.56a0792a.png";